import { DataSetEventTypeEnums } from '@/enums/DataSetEventTypeEnums';
import { DataSetEventStatusTypeEnums } from '@/enums/DataSetEventStatusTypeEnums';
import { DataSetEditor } from '@/models/dataset/DataSetEditor';
import { IDataSetBase, DataSetBase } from '@/models/dataset/DataSetBase';


export interface IDexieDataSetEvent {
    id?: number;
    dataSet: IDataSetBase;
    /**
     * Server-synced snapshot captured before optimistic local updates.
     * Used during sync to compute the delta sent to /events/update.
     */
    previousDataSet?: IDataSetBase;
    event: DataSetEventTypeEnums;
    eventStatus?: DataSetEventStatusTypeEnums;
    eventStatusInfo?: string;
    date: string;
    user?: DataSetEditor;
}

export class DexieDataSetEvent implements IDexieDataSetEvent {
    public id?: number;
    public dataSet: DataSetBase;
    public previousDataSet?: DataSetBase;
    public event: DataSetEventTypeEnums;
    public eventStatus?: DataSetEventStatusTypeEnums;
    public eventStatusCode?: number;
    public eventStatusInfo?: string;
    public date: string;
    public user?: DataSetEditor;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDexieDataSetEvent);
    constructor(obj?: any) {
        // do not set id to undefined or dexie.js will throw an error
        if (obj && obj.id != null) {
            this.id = obj.id;
        }

        this.event = obj && obj.event != null ? obj.event : DataSetEventTypeEnums.UNKNOWN;
        this.eventStatus = obj && obj.eventStatus != null ? obj.eventStatus : undefined;
        this.eventStatusCode = obj && obj.eventStatusCode != null ? obj.eventStatusCode : undefined;
        this.eventStatusInfo = obj && obj.eventStatusInfo != null ? obj.eventStatusInfo : undefined;

        this.date = obj && obj.date || (new Date()).toISOString();
        if (obj && obj.dataSet) {
            this.dataSet = new DataSetBase(obj.dataSet);
        } else {
            this.dataSet = new DataSetBase();
        }

        if (obj && obj.previousDataSet) {
            this.previousDataSet = new DataSetBase(obj.previousDataSet);
        }

        if (obj && obj.user) {
            this.user = obj.user;
        }
    }
}
